var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "security-fallback-tab" },
    [
      _c("div", { staticClass: "tab-header" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("voiceagent.securityBackupTabTitle")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(_vm._s(_vm.$t("voiceagent.securityBackupTabDescription"))),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-form",
        { staticClass: "settings-form", attrs: { layout: "vertical" } },
        [
          _c("div", { staticClass: "settings-section" }, [
            _c(
              "div",
              { staticClass: "setting-header" },
              [
                _c("div", { staticClass: "setting-title" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("voiceagent.sensitiveDataOptOut"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-description" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$t("voiceagent.sensitiveDataOptOutDescription")
                        ) +
                        "\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  on: { change: _vm.updateSettings },
                  model: {
                    value: _vm.formData.opt_out_sensitive_data_storage,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "opt_out_sensitive_data_storage",
                        $$v
                      )
                    },
                    expression: "formData.opt_out_sensitive_data_storage",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "setting-content" }, [
              _c(
                "div",
                { staticClass: "description" },
                [
                  _c("a-alert", { attrs: { type: "info", "show-icon": "" } }, [
                    _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.$t("voiceagent.sensitiveDataOptOutAlert")
                          ) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("voiceagent.fallbackVoiceSection"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("voiceagent.fallbackVoiceIntro")) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "setting-content" },
              [
                _c("div", { staticClass: "description" }, [
                  _c("p", [
                    _vm._v(
                      "\n                        Seçilen yedek sesler, ana ses servis dışı kaldığında sırayla kullanılır. Yedek sesler ana\n                        ses sağlayıcısından farklı olmalıdır.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.formData.fallback_voice_ids &&
                _vm.formData.fallback_voice_ids.length > 0
                  ? _c("div", { staticClass: "selected-fallback-voices" }, [
                      _c("h5", [
                        _vm._v(
                          _vm._s(_vm.$t("voiceagent.selectedFallbackVoices"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fallback-voice-list" },
                        _vm._l(
                          _vm.formData.fallback_voice_ids,
                          function (voiceId, index) {
                            return _c(
                              "a-tag",
                              {
                                key: index,
                                attrs: { closable: "" },
                                on: {
                                  close: function ($event) {
                                    return _vm.removeVoiceFromFallback(index)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getVoiceName(voiceId)) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-voice-button",
                    attrs: { type: "dashed" },
                    on: { click: _vm.showVoiceSelector },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("voiceagent.addFallbackVoice")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a-modal",
                  {
                    attrs: {
                      title: _vm.$t("voiceagent.fallbackVoiceModalTitle"),
                      width: "800px",
                      footer: null,
                    },
                    model: {
                      value: _vm.voiceSelectorVisible,
                      callback: function ($$v) {
                        _vm.voiceSelectorVisible = $$v
                      },
                      expression: "voiceSelectorVisible",
                    },
                  },
                  [
                    _c("p", { staticClass: "modal-info" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("voiceagent.fallbackVoiceModalHint")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("voice-selector", {
                      on: { select: _vm.addVoiceToFallback },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settings-section" }, [
            _c("div", { staticClass: "setting-header" }, [
              _c("h4", [
                _vm._v(_vm._s(_vm.$t("voiceagent.defaultDynamicVars"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-description" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t("voiceagent.defaultDynamicVarsIntro")) +
                    "\n                "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "setting-content" },
              [
                _c("div", { staticClass: "description" }, [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("voiceagent.promptVariablesDefaultValue"))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.extractedVariables.length > 0
                  ? _c(
                      "div",
                      { staticClass: "extracted-variables-info" },
                      [
                        _c(
                          "a-alert",
                          { attrs: { type: "success", "show-icon": "" } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "message" }, slot: "message" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("voiceagent.dynamicVarsAlertFound")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.extractedVariables,
                                  function (variable) {
                                    return _c("a-tag", { key: variable }, [
                                      _vm._v(_vm._s(variable)),
                                    ])
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dynamic-variables-list" },
                  _vm._l(_vm.dynamicVariables, function (value, key, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "dynamic-variable-item" },
                      [
                        _c("div", { staticClass: "variable-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "variable-input-group" },
                            [
                              _c("a-input", {
                                staticClass: "variable-key",
                                attrs: {
                                  "addon-before": "{{",
                                  "addon-after": "}}",
                                  value: key,
                                  placeholder: _vm.$t(
                                    "voiceagent.variableKeyPlaceholder"
                                  ),
                                },
                                on: {
                                  change: function (e) {
                                    return _vm.updateVariableKey(
                                      key,
                                      e.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("a-input", {
                                staticClass: "variable-value",
                                attrs: {
                                  placeholder: _vm.$t(
                                    "voiceagent.variablePlaceholder"
                                  ),
                                },
                                on: { change: _vm.updateSettings },
                                model: {
                                  value: _vm.dynamicVariables[key],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dynamicVariables, key, $$v)
                                  },
                                  expression: "dynamicVariables[key]",
                                },
                              }),
                              _vm._v(" "),
                              _c("a-button", {
                                attrs: { type: "danger", icon: "delete" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeVariable(key)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    staticClass: "add-variable-button",
                    attrs: { type: "dashed" },
                    on: { click: _vm.addVariable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("voiceagent.addVariable")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["voice-agent.update"] } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.saveSettings },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("voiceagent.saveChangesButton")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }